import { withZod } from '@remix-validated-form/with-zod';
import { cleanTextField } from '@theprintbar/shared';
import { z } from 'zod';
import { zfd } from 'zod-form-data';

export const contactSchema = z.object({
	firstName: cleanTextField,
	lastName: cleanTextField,
	email: z.string().email('Please enter a valid email'),
	subject: cleanTextField,
	message: cleanTextField,
	newsletter: zfd.checkbox(),
	attachments: z.string().optional(),
	source: z.string().optional(),
});

export const contactServerSchema = contactSchema.extend({
	attachments: z.array(z.object({ size: z.coerce.number(), file: z.string() })).optional(),
});

export const contactFormParams = z.object({
	subject: z.string().optional(),
	source: z.string().optional(),
});

export const contactSchemaValidator = withZod(contactSchema);
export const contactServerSchemaValidator = withZod(contactServerSchema);

export type ContactSchemaForm = z.infer<typeof contactSchema>;
